import React from "react";
import { MenuAlt2Icon } from "@heroicons/react/outline";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
// import MainLogo from "../images/agro-logo.png";
import { useDispatch, useSelector } from "react-redux";
import { contracts, login, logout } from "../redux/actions/auth";
import { useNavigate } from "react-router-dom";
import { IoWalletSharp } from "react-icons/io5";
import { ethers } from "ethers";
import BlueTokenAbi from "../abis/CarboXBlue.json";
import GreenTokenAbi from "../abis/CarboXGreen.json";
import { useEffect } from "react";
import { toast } from "react-toastify";

function TopBar({ setSidebarOpen }) {
  // const userNavigation = [{ name: "Sign out", href: "/signin" }];

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const handleLogout = () => {
  //   dispatch(logout());
  //   navigate("/signin", { replace: true });
  // };

  // const loadContracts = async () => {
  //   let provider;
  //   let signer;

  //   provider = new ethers.providers.Web3Provider(window.ethereum);
  //   await provider.send("eth_requestAccounts", []);
  //   signer = provider.getSigner();

  //   // dispatch(providerDispatch(provider));

  // };

  const { user } = useSelector((state) => state.auth);

  const loadContracts = async () => {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    await provider.send("eth_requestAccounts", []);
    let signer = provider?.getSigner();

    const newContracts = {
      greenToken: new ethers.Contract(
        GreenTokenAbi.address,
        GreenTokenAbi.abi,
        signer
      ),
      blueToken: new ethers.Contract(
        BlueTokenAbi.address,
        BlueTokenAbi.abi,
        signer
      ),
    };
    dispatch(contracts(newContracts));
  };

  const connectWallet = async () => {
    try {
      if (typeof window.ethereum != undefined) {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        await provider.send("eth_requestAccounts", []);
        let signer = provider?.getSigner();

        // const user = await queryUser(
        //   "0xcbdf2ed33c81d7367fbe2bcc793ef4e2a6a8f412"
        // );

        console.log(signer);

        const user = {
          signer: await signer?.getAddress(),
        };

        const newContracts = {
          greenToken: new ethers.Contract(
            GreenTokenAbi.address,
            GreenTokenAbi.abi,
            signer
          ),
          blueToken: new ethers.Contract(
            BlueTokenAbi.address,
            BlueTokenAbi.abi,
            signer
          ),
        };
        dispatch(contracts(newContracts));

        dispatch(login(user));
        // console.log("Wallet connected");
        toast.success("Wallet connected successfully");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadContracts();
  }, []);

  window?.ethereum?.on("accountsChanged", (accounts) => {
    if (!accounts.length) {
      dispatch(logout());
      navigate("/", { replace: true });
    }
  });

  return (
    <div class="top-bar">
      <button
        onClick={() => {
          !user?.signer && connectWallet();
        }}
        type="button"
        className="outline-btn"
        style={{ overflow: "hidden", width: "180px" }}
      >
        {user?.signer ? (
          <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
            {user?.signer}
          </div>
        ) : (
          <div className="">Connect Wallet</div>
        )}
      </button>

      {/* <button
        type="button"
        className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none md:hidden"
        onClick={() => setSidebarOpen(true)}
      >
        <span className="sr-only">Open sidebar</span>
        <MenuAlt2Icon className="h-6 w-6" aria-hidden="true" />
      </button> */}
      <div
        style={{ display: "none" }}
        className="flex-1 px-4 flex justify-between"
      >
        <div className="flex-1 flex"></div>
        <div className="ml-4 flex items-center md:ml-6">
          <Menu as="div" className="ml-3 relative">
            <div>
              <button
                onClick={() => {
                  !user?.signer && connectWallet();
                }}
                type="button"
                style={{ overflow: "hidden", width: "180px" }}
                className="w-44 py-2 flex justify-center items-center mt-2 px-4 border border-transparent rounded-md text-sm font-medium text-white bg-[#00AB55] shadow-lg shadow-green-500/50 hover:bg-[#00AB55]  focus:outline-none"
              >
                {user?.signer ? (
                  <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                    {user?.signer}
                  </div>
                ) : (
                  <div className="flex items-center">
                    <IoWalletSharp /> &nbsp; Connect Wallet
                  </div>
                )}
              </button>
            </div>
          </Menu>
        </div>
      </div>
    </div>
  );
}

export default TopBar;
